<div [class]="styleClass">
    <h3>{{ title }}</h3>
    <a class="close" (click)="closeInformative()">&times;</a>
</div>